import { useState, forwardRef, useImperativeHandle } from "react";
import { MultiSelect } from "react-multi-select-component";
import DateTimePicker from "react-datetime-picker";

import Checkbox from "components/Checkbox";
import { formattedCanadianProvinces, formattedUSStates, destinationRenderer, prepareForFetch } from "./helpers";

import styles from "./Filter.module.scss";

const Filter = forwardRef(({ open, socket }, ref) => {
  
  const [selectedP, setSelectedP] = useState({
    destination: [],
    list: [
      ...formattedUSStates, 
      ...formattedCanadianProvinces
    ]
  });
  const [selectedD, setSelectedD] = useState({
    destination: [],
    list: [...formattedUSStates, ...formattedCanadianProvinces],
  });

  const handleSelectionChange = (selectedOptions, setState) => {
    const isAllUSASelected = selectedOptions.some(item => item.value === "ALL_USA");
    const isAllCanadaSelected = selectedOptions.some(item => item.value === "ALL_CANADA");
  
    let newDestinations = [];
  
    if (isAllUSASelected) {
      newDestinations = [selectedOptions.find(item => item.value === "ALL_USA")];
    } 
    else if (isAllCanadaSelected) {
      newDestinations = [selectedOptions.find(item => item.value === "ALL_CANADA")];
    }
  
    selectedOptions.forEach(item => {
      if (isAllUSASelected && item.value !== "ALL_USA" && item.label.includes("Canada")) {
        newDestinations.push(item);
      }
      else if (isAllCanadaSelected && item.value !== "ALL_CANADA" && item.label.includes("USA")) {
        newDestinations.push(item);
      }
      else if (!isAllUSASelected && !isAllCanadaSelected) {
        newDestinations.push(item);
      }
    });
      newDestinations = [...new Set(newDestinations)];
  
    setState({ ...selectedP, destination: newDestinations });
  };
  
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  
  const [fromDateD, setFromDateD] = useState();
  const [toDateD, setToDateD] = useState();
  
  const [showPickers, setShowPickers] = useState(false); 
  const [showPickersD, setShowPickersD] = useState(false); 
  
  const handleContainerClick = () => {
    handleInputClick(false);
    setShowPickers(true);
  };
  const handleContainerClickD = () => {
    handleInputClick(false);
    setShowPickersD(true);
  };

  const initialMaxState = {
    range: { from: null, to: null, bool: false },
    length: { value: null, bool: false },
    width: { value: null, bool: false },
    height: { value: null, bool: false },
    weight: { value: null, bool: false },
    milesOut: { value: null, bool: false }
  };

  const [max, setMax] = useState(initialMaxState);
  const [onlyMy, setOnlyMy] = useState(false)

  const handleInputClick = (field) => {
    setMax((prevMax) => {
      const updatedMax = {};
        if (field === false) {
          for (let key in prevMax) {
            updatedMax[key] = {
              ...prevMax[key],
              bool: false,
            };
        }
      } else {
          
        for (let key in prevMax) {
          updatedMax[key] = {
            ...prevMax[key],
            bool: key === field,
          };
        }
      }
      return updatedMax;
    });
  };
  
  const handleInputChange = (field, newValue, type) => {
    setMax((prevMax) => ({
      ...prevMax,
      [field]: {
        ...prevMax[field],
        [type]: newValue === '' ? null : Number(newValue)
      }
    }));
  };

  
  const handleSubmit = (e) => {
    const resultData = {
      "pick_up_from": prepareForFetch(selectedP.destination),
      "pick_up_date": {
        "from": fromDate ? fromDate: null,      
        "to": toDate ? toDate: null,
      },
      "delivery_to": prepareForFetch(selectedD.destination), 
      "delivery_date": {
        "from": fromDateD ? fromDateD : null,
        "to": toDateD ? toDateD : null
      },
      "mile": {
        "min": max.range.from ? max.range.from : null,
        "max": max.range.to ? max.range.to : null
      },
      "max_length": max.length.value ? max.length.value : null,
      "max_width": max.width.value ? max.width.value : null,
      "max_height": max.height.value ? max.height.value : null,
      "max_weight": max.weight.value ? max.weight.value : null,
      "max_miles_out": max.milesOut.value ? max.milesOut.value : null,
      "my_trucks_only": onlyMy
    }

    if (socket && socket.readyState === WebSocket.OPEN) {
      // socket send Json
      socket.send(JSON.stringify({filters: resultData}));
    } else {
      console.error("WebSocket is not connected.");
    }
  };

  // button Clear All
  useImperativeHandle(ref, () => ({
    clearAllStates() {
      setSelectedD({destination: [],
        list: [...formattedUSStates, ...formattedCanadianProvinces],})
      setSelectedP({destination: [],
        list: [...formattedUSStates, ...formattedCanadianProvinces],})
      setFromDate()
      setToDate()
      setShowPickers(false)
      setFromDateD()
      setToDateD()
      setShowPickersD(false)
      setMax(initialMaxState);
      setOnlyMy(false)
    },
  getCurrentFilterValues() {
    return {
      // selectedD,
      // selectedP,
      // fromDate,
      // toDate,
      // showPickers,
      // fromDateD,
      // toDateD,
      // showPickersD,
      // max,
      onlyMy,
    };
  }
  }));
  
  return (
    <div className={styles.wrapper}>
      {open && (
        <div className={styles.form} >
          <div className={styles.group} onClick={() => handleInputClick(false)}>
            <MultiSelect
              className={styles.select}
              options={selectedP.list && selectedP.list}
              hasSelectAll={false}
              value={selectedP.destination && selectedP.destination}
              onChange={(selectedOptions) => handleSelectionChange(selectedOptions, setSelectedP)}
              valueRenderer={() => destinationRenderer(selectedP.destination, "Pick-up from")}
            />
          </div>
          <div className={styles.group}>
            <div className={styles.singleInput} onClick={handleContainerClick}>
              {showPickers 
                ?<span className={`${styles.toText} ${styles.toTextUpper}`}>Pick-up date</span>
                  :  <span className={styles.toText}>Pick-up date</span>}
              {showPickers && (
                <div className={styles.opened}>
                  <DateTimePicker
                    onChange={setFromDate}
                    value={fromDate}
                    format="MM/dd h:mm a"
                    calendarIcon={null}
                    disableClock={true}
                    clearIcon={null}
                    className={styles.halfInput}
                  />
                  <span className={styles.divider}>-</span>
                  <DateTimePicker
                    onChange={setToDate}
                    value={toDate}
                    format="MM/dd h:mm a"
                    calendarIcon={null}
                    disableClock={true}
                    clearIcon={null}
                    className={styles.halfInput}
                  />
                </div>
              )}
            </div>
          </div>        
          <div className={styles.group} onClick={() => handleInputClick(false)}>
            <MultiSelect
              className={styles.select}
              options={selectedD.list && selectedD.list}
              value={selectedD.destination && selectedD.destination}
              hasSelectAll={false}
              onChange={(selectedOptions) => handleSelectionChange(selectedOptions, setSelectedD)}
              valueRenderer={() => destinationRenderer(selectedD.destination, "Delivery to")}
            />
          </div>  
          <div className={styles.group}>
            <div className={styles.singleInput} onClick={handleContainerClickD}>
              {showPickersD 
                ?<span className={`${styles.toText} ${styles.toTextUpper}`}>Delivery date</span>
                  :  <span className={styles.toText}>Delivery date</span>}
              {showPickersD && (
                <div className={styles.opened}>
                  <DateTimePicker
                    onChange={setFromDateD}
                    value={fromDateD}
                    format="MM/dd h:mm a"
                    calendarIcon={null}
                    disableClock={true}
                    clearIcon={null}
                    className={styles.halfInput}
                  />
                  <span className={styles.divider}>-</span>
                  <DateTimePicker
                    onChange={setToDateD}
                    value={toDateD}
                    format="MM/dd h:mm a"
                    calendarIcon={null}
                    disableClock={true}
                    clearIcon={null}
                    className={styles.halfInput}
                    showTimeSelect
                  />
                </div>
              )}
            </div>
          </div> 
          
          <div className={styles.group}>
            <div className={styles.inputs} onClick={() => handleInputClick('range')}>
              <span className={styles.toText}>Mile Range</span>
              {max.range.bool ? (
                <div className={styles.input_ranges}>
                  <input
                    type="number"
                    className={styles.input}
                    value={max.range.from || ''}
                    onChange={(e) => handleInputChange('range', e.target.value, 'from')}
                    onBlur={() => {
                      if (max.range.from !== null && max.range.to !== null && Number(max.range.from) > Number(max.range.to)) {
                        handleInputChange('range', max.range.from, 'to');
                      }
                    }}
                  />
                  <span className={styles.toText}> - </span>
                  <input
                    type="number"
                    className={styles.input}
                    value={max.range.to || ''}
                    onChange={(e) => handleInputChange('range', e.target.value, 'to')}
                    onBlur={() => {
                      if (max.range.to < max.range.from) {
                        handleInputChange('range', max.range.to, 'from');
                      }
                    }}
                  />
                  <span className={styles.toText}>ml</span>
                </div>
              ) : (
                max.range.from &&
                max.range.to && (
                  <span className={styles.toTextSelected}>
                    {max.range.from} - {max.range.to} ml
                  </span>
                )
              )}
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.inputs} onClick={() => handleInputClick('length')}>
              <span className={styles.toText}>Max Length</span>
              {max.length.bool && (
                <>
                  <input
                    type="number"
                    className={styles.input}
                    value={max.length.value || ''}
                    onChange={(e) => {
                      const value = e.target.value;               
                      if (value.length <= 3) {
                        handleInputChange('length', value, 'value');
                      }
                    }}
                  />
                  <span className={styles.toText}>in</span>
                </>
              )}
              {!max.length.bool && max.length.value && (
                <span className={styles.toTextSelected}>{max.length.value} in</span>
              )}
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.inputs} onClick={() => handleInputClick('width')}>
              <span className={styles.toText}>Max Width</span>
              {max.width.bool && (
                <>
                  <input
                    type="number"
                    value={max.width.value || ''}
                    className={styles.input}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 3) {
                        handleInputChange('width', value, 'value');
                      }
                    }}
                  />
                  <span className={styles.toText}>in</span>
                </>
              )}
              {!max.width.bool && max.width.value && (
                <span className={styles.toTextSelected}>{max.width.value} in</span>
              )}
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.inputs} onClick={() => handleInputClick('height')}>
              <span className={styles.toText}>Max Height</span>
              {max.height.bool && (
                <>
                  <input
                    type="number"
                    value={max.height.value || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 3) {
                        handleInputChange('height', value, 'value');
                      }
                    }}
                    className={styles.input}
                    />
                    <span className={styles.toText}>in</span>
                </>
              )}
              {!max.height.bool && max.height.value && (
                <span className={styles.toTextSelected}>{max.height.value} in</span>
              )}
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.inputs} onClick={() => handleInputClick('weight')}>
              <span className={styles.toText}>Max weight</span>
              {max.weight.bool && (
                <>
                  <input
                    type="number"
                    value={max.weight.value || ''}
                    onChange={(e) => {
                      const value = e.target.value;                
                      if (value.length <= 4) {
                        handleInputChange('weight', value, 'value');
                      }
                    }}
                    className={`${styles.input} ${styles.weight}`}
                    />
                    <span className={styles.toText}>lb</span>
                </>
              )}
              {!max.weight.bool && max.weight.value && (
                <span className={styles.toTextSelected}>{max.weight.value} lb</span>
              )}
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.inputs} onClick={() => handleInputClick('milesOut')}>
              <span className={styles.toText}>Max Miles Out</span>
              {max.milesOut.bool && (
                <>
                  <input
                    type="number"
                    value={max.milesOut.value || ''}
                    max={300}
                    onChange={(e) => handleInputChange('milesOut', Math.min(e.target.value, 300), 'value')}
                    className={styles.input}
                  />
                  <span className={styles.toText}>ml</span>
                </>
              )}
              {!max.milesOut.bool && max.milesOut.value && (
                <span className={styles.toTextSelected}>{max.milesOut.value} ml</span>
              )}
            </div>
          </div>

          <div className={styles.group}>
            <div className={styles.checkbox} onClick={() => handleInputClick(false)}>
              <span className={styles.toText}>My trucks only</span>
              <Checkbox
                id="onlyMy"
                label=""
                value={onlyMy}
                onChange={() => setOnlyMy(!onlyMy)}
              />
            </div>
          </div>
          <button
          onClick={handleSubmit}
            className={styles.submitButton}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
});

export default Filter;
